'use client'

import { usePathname } from 'next/navigation'

import { Paragraph } from '@graftcode/design-system'

import { useLayoutStore } from '../../stores/layout.store'

import styles from './Loader.module.scss'

export function Loader() {
  const pathname = usePathname()
  const { isLoading, loaderMessage } = useLayoutStore()

  const isSettingsRoute = pathname?.includes('/settings') ?? false

  if (!isLoading || isSettingsRoute) {
    return null
  }

  return (
    <div className={styles.overlay}>
      <div className={styles.container}>
        <div className={styles.loader}>
          <div className={styles.spinner}></div>
        </div>

        <Paragraph size="sm" className={styles.message}>
          {loaderMessage}
        </Paragraph>
      </div>
    </div>
  )
}
